<template>
  <div class="website">
    <headerBlack-view></headerBlack-view>
    <div class="website_wrap flex-align-wrap">
      <div
        class="website_item csp flex-align-around"
        :class="{'website_item2':(index+1)%4==0}"
        v-for="(item,index) in list"
        :key="index"
        @click="goPage(item)"
      >
        <img :src="item.img" v-if="item.img"/>
        <p v-if="item.title" class="title">{{item.title}}</p>
        <div class="item_shadow flex-align-around">
          <span>{{item.name}}</span>
        </div>
      </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {
  data(){
    return {
      list:[
        {
          name:'乐智悦读',
          link:'https://www.lezhireading.com/',
          img:require('@/assets/topic/lzreading.png')
        },
        {
          name:'靠谱联盟',
          link:'http://www.tocop.cn/',
          img:require('@/assets/topic/tocop.png')
        },
        // {
        //   name:'银川市中小学学生综合素质评价平台',
        //   link:'https://yczs-mgmt.yzhtech.com/#/login?reInitSession=false',
        //   title:'银川市中小学学生综合素质评价平台'
        // },
        {
          name:'关于智慧后勤运营职业技能等级证书考核费用标准（河南省）的公告',
          link:'//news.ys.cnuen.net/pdf/%E8%81%8C%E4%B8%9A%E6%8A%80%E8%83%BD%E7%AD%89%E7%BA%A7%E8%AF%81%E4%B9%A6%E8%80%83%E6%A0%B8%E6%94%B6%E8%B4%B9%E8%AE%BA%E8%AF%81%E6%96%B9%E6%A1%88.pdf',
          title:'关于智慧后勤运营职业技能等级证书考核费用标准（河南省）的公告'
        }
      ]
    }
  },
  methods:{
    goPage(item){
      window.open(item.link);
    }
  }
};
</script>

<style lang="less">
@import "./website.less";
</style>